import $ from "../components/ajax";
const token =localStorage.getItem("token");
//获取已登记作品
export const getRegisterApproved=data=>{
    return $.ajax({
        url:"info/list",
        type:'GET',
        data:data,
        token,
    })
}
//获取作品详情
export const getRegisterDetail=data=>{
  return $.ajax({
      url:"info/"+data,
      type:'GET',
      //data:data,
      token,
  })
}
//加入作品列表
export const addProduct=data=>{
  return $.ajax({
      url:"product/add",
      type:'GET',
      data:data,
      token,
  })
}

//选为素材/移除素材
export const updateMaterial=data=>{
  return $.ajax({
      url:"product/update-material",
      type:'PUT',
      data:data,
      token,
  })
}
//查询当前用户勾选的作品ids
export const userProductIds=data=>{
  return $.ajax({
      url:"product/userProductIds",
      type:'GET',
      data:data,
      token,
  })
}

//显示隐藏作品
export const hideProduct=data=>{
  return $.ajax({
      url:"info/changeHideStatus",
      type:'GET',
      data:data,
      token,
  })
}

//获取绑定作品
export const getProductList=data=>{
  return $.ajax({
      url:"info/getProductListByUser",
      type:'GET',
      data:data,
      token,
  })
}

//移除绑定作品
export const removeProductList=data=>{
  return $.ajax({
      url:"product/removeUserProduct",
      type:'GET',
      data:data,
      token,
  })
}

//导出
export const exportProductList=data=>{
  return $.ajax({
      url:"info/export",
      type:'POST',
      data:data,
      token,
  })
}